import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ROUTE_TITLES = {
  '/': 'Home',
  '/schedule': 'Schedule',
  '/watch': 'Watch',
  '/channels': 'Channels',
  '/guide': 'Guide',
  '/news': 'News',
  '/events': 'Events',
  '/careers': 'Careers',
  '/contact': 'Contact',
  '/podcasts': 'Podcasts',
  '/record-book': 'Record Book',
  '/leagues': 'Leagues',
  '/leaderboard': 'Leaderboard',
  '/photos': 'Photos',
  '/galleries': 'Galleries',
  '/multiview': 'Multi View',
  '/on-demand': 'On Demand',
  '/admin': 'Admin',
  '/login': 'Login',
  '/login-user': 'Sign In',
  '/signup': 'Sign Up',
  '/account': 'My Account',
  '/forgot-password': 'Forgot Password',
  '/sponsor/signup': 'Sponsor Sign Up',
  '/sponsor/login': 'Sponsor Login',
  '/sponsor/portal': 'Sponsor Portal',
  '/writer/setup': 'Writer Setup',
  '/writer/login': 'Writer Login',
  '/writer/portal': 'Writer Portal',
  '/photographer/signup': 'Photographer Sign Up',
  '/photographer/login': 'Photographer Login',
  '/photographer/portal': 'Photographer Portal',
};

const DYNAMIC_PREFIXES = [
  { prefix: '/game/', title: 'Game' },
  { prefix: '/game-recap/', title: 'Game Recap' },
  { prefix: '/watch/', title: 'Channel' },
  { prefix: '/on-demand/', title: 'Recording' },
  { prefix: '/news/', title: 'Article' },
  { prefix: '/events/', title: 'Event' },
  { prefix: '/league/', title: 'League' },
  { prefix: '/team/', title: 'Team' },
  { prefix: '/network/', title: 'Network' },
  { prefix: '/photos/', title: 'Photo' },
  { prefix: '/galleries/', title: 'Gallery' },
  { prefix: '/picks/', title: 'Picks' },
  { prefix: '/watch-party/', title: 'Watch Party' },
  { prefix: '/admin/channel/', title: 'Channel Settings' },
  { prefix: '/admin/event/', title: 'Event Editor' },
];

export function usePageTitle(customTitle) {
  useEffect(() => {
    if (customTitle) {
      document.title = `ASN | ${customTitle}`;
    }
  }, [customTitle]);
}

export function PageTitleManager() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    // Check exact routes first
    if (ROUTE_TITLES[path]) {
      document.title = `ASN | ${ROUTE_TITLES[path]}`;
      return;
    }

    // Check dynamic prefixes
    for (const { prefix, title } of DYNAMIC_PREFIXES) {
      if (path.startsWith(prefix)) {
        document.title = `ASN | ${title}`;
        return;
      }
    }

    // Fallback
    document.title = 'ASN | Antler Sports Network';
  }, [location.pathname]);

  return null;
}
